export const defaultFontSize = '18px';
export const defaultLineHeight = '29px';
export const defaultLetterSpacing = '1.8px';
export const defaultFontFamily = 'Poppins';
export const altFontFamily = 'Merlin';

export const backgroundColor = 'linear-gradient(to right, #FFFCFC, #ffe9e9)';
export const neutral = '#4F4549';
export const neutralLight = '#9D9498';
export const neutralLighter = '#bfb3b8';
export const white = '#ffffff';

export const pink = '#FDD8E7';
export const pinkDark = '#F8B1CD';

export const green = '#CDD9BE';

export const yellow = '#FFE87F';

export const brown = '#BCA798';
export const brownDark = '#A99180';

export const red = '#FF8585';

export const blue = '#B9D9FF';

export const margin = '20px';
export const marginSmall = '10px';
export const marginLarge = '30px';

export const padding = margin;
export const paddingSmall = marginSmall;
export const paddingLarge = marginLarge;

export const transitionTime = '0.2s';

export const curve = 'cubic-bezier(1, -0.07, 0.51, 1)';

export const transition = `all ${transitionTime} ${curve}`;

export const screenXs = 'only screen and (max-width: 320px)';
export const screenS = 'only screen and (max-width: 375px)';
export const screenM = 'only screen and (max-width: 425px)';
export const screenL = 'only screen and (max-width: 768px)';
export const screenXl = 'only screen and (max-width: 1024px)';
export const screenHuge = 'only screen and (min-width: 1024px)';

// To target specific screen ratios
export const phoneSLandscape = `${screenS} and (orientation: landscape)`;
export const phoneSPortrait = `${screenXs} and (orientation: portrait)`;

export const phoneLandscape = `${screenL} and (orientation: landscape)`;
export const phonePortrait = `${screenM} and (orientation: portrait)`;

export const tabletLandscape = `${screenXl} and (orientation: landscape)`;
export const tabletPortrait = `${screenL} and (orientation: portrait)`;
